import { render, staticRenderFns } from "./dg-upload2.vue?vue&type=template&id=a0568a22&scoped=true"
import script from "./dg-upload2.vue?vue&type=script&lang=js"
export * from "./dg-upload2.vue?vue&type=script&lang=js"
import style0 from "./dg-upload2.vue?vue&type=style&index=0&id=a0568a22&prod&lang=less&scoped=true"
import style1 from "./dg-upload2.vue?vue&type=style&index=1&id=a0568a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0568a22",
  null
  
)

export default component.exports